<template>
  <component :is="isNew ? IOrderMenu : IOrderMenuLegacy" v-bind="props" />
</template>

<script setup>
import { inject } from 'vue';
import IOrderMenu from './IOrderMenuNew.vue';
import IOrderMenuLegacy from '../IOrderMenuLegacy/IOrderMenuLegacy.vue';

const props = defineProps({
  fields: {
    type: Object,
    default: () => ({}),
  },
  rendering: {
    type: Object,
  },
  params: {
    type: Object,
  },
});

const jssStore = inject('jssStore');
const featureFlag = jssStore?.sitecoreContext()?.['Feature.Menus.UseEnterpriseMenuApi'];
const isNew = featureFlag === 'true';
</script>

<style lang="scss">
@import './scss/IOrderMenu.scss';
</style>
